import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import { Chart } from "chart.js";

export default function ColumnChartForAdmin() {
  const [columnData, setColumnData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

  const storedUserData = localStorage.getItem('userData');
  let userId = '';
  let groupId = '';

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetTotalDrCrUserwise`
        );
        const data = await response.json();
        setColumnData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedYear, selectedMonth]);

  useEffect(() => {
    if (columnData.length === 0) {
      // Destroy the existing chart instance if it exists
      if (window.myBar) {
        window.myBar.destroy();
      }

      // Display a message or handle no data scenario
      const ctx = document.getElementById("bar-chart1").getContext("2d");
      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height); // Clear the canvas
      ctx.fillText("No data found", ctx.canvas.width / 2, ctx.canvas.height / 2);
      return;
    }

    // Destroy the existing chart instance if it exists
    if (window.myBar) {
      window.myBar.destroy();
    }

    const config = {
      type: "bar",
      data: {
        labels: columnData.map((item) => item.userName),
        datasets: [
          {
            label: "Total Debit",
            data: columnData.map((item) => item.totalDebit),
            backgroundColor: "#ed64a6",
            borderWidth: 1,
          },
          {
            label: "Total Credit",
            data: columnData.map((item) => item.totalCredit),
            backgroundColor: "#4c51bf",
            borderWidth: 1,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: 'top', // Adjust position as needed
          },
          title: {
            display: true,
            text: "Expense Distribution",
          },
        },
        scales: {
          x: {
            display: true,
            title: {
              display: true,
              text: "Users",
            },
          },
          y: {
            display: true,
            title: {
              display: true,
              text: "Amount",
            },
          },
        },
        plugins: {
          datalabels: {
            display: false,
            color: 'brown', // Font color for labels
            font: {
              weight: 'bold', // Bold font weight
              size: 14 // Font size in pixels
            },
            formatter: (value) => { // Custom label formatter function to display only value
              return value;
            }
          }
        }
      },
    };

    const ctx = document.getElementById("bar-chart1").getContext("2d");
    window.myBar = new Chart(ctx, config);
  }, [columnData]);


  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full max-w-full flex-grow flex-1">
              <h2 className="text-blueGray-700 text-xl font-semibold">Users Expenses</h2>
            </div>
          </div>
        </div>
        <div className="p-4 flex-auto">
          <div className="relative h-350-px">
            <canvas id="bar-chart1"></canvas>
          </div>
        </div>
      </div>
    </>
  );
}
